/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'core';
const componentName = 'central-license-alerts';
const prefix = `${moduleName}.${componentName}`;

export const controllerNotRegisteredMessage = `${prefix}.controllerNotRegisteredMessage`;
export const registerControllerButtonText = `${prefix}.registerControllerButtonText`;
export const retryNowButtonText = `${prefix}.retryNowButtonText`;
export const licenseEnforcementAlertMessage = `${prefix}.licenseEnforcementAlertMessage`;

export const ENGLISH = {
    [controllerNotRegisteredMessage]: 'Register your Controller with Cloud Services to complete product activation.',
    [registerControllerButtonText]: 'Register Controller',
    [retryNowButtonText]: 'Retry Now',
    [licenseEnforcementAlertMessage]: 'License your controller with ESSENTIALS tier serial key before {0} to continue using it. After this date, new service engines cannot be provisioned.',
};
